import { render } from "./mini-calendar-loading.vue?vue&type=template&id=452cffb2"
import script from "./mini-calendar-loading.vue?vue&type=script&lang=js"
export * from "./mini-calendar-loading.vue?vue&type=script&lang=js"

import "./mini-calendar-loading.vue?vue&type=style&index=0&id=452cffb2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__